export default "//static.tradera.net/touchweb/static/output/images/multicolor.54fc068a.svg";